import config from "@/config";

const defaultHeaders = {
  Accept: "application/json",
  // "Content-Type": "application/json",
  X_REQUESTED_WITH: "XMLHttpRequest",
};

export type Payload = {
  action: "searchtollfree" | "searchareacode";
  maxresults: number;
  areacode: string;
  pattern?: string;
};

export const searchPhoneNumber = async (data: Payload) => {
  let res = null;

  const formData = new FormData();
  formData.append("action", data.action);
  formData.append("maxresults", data.maxresults.toString());
  formData.append("areacode", data.areacode);

  if (data.pattern) {
    formData.append("pattern", data.pattern);
  }

  try {
    res = await fetch(`${config.baseUrl}/ajax/getdids.php`, {
      method: "POST",
      headers: defaultHeaders,
      body: formData,
    });

    return res.json();
  } catch (error) {
    throw new Error(
      "We are unable to get AI answer. Please try again. If the issue keep happening, contact Support.",
    );
  }
};
